import React, { 
  Component
} from 'react';

import {
  Theme,
  Text,
  Tag,
  LinkButton,
  ButtonGroup
} from '@resultadosdigitais/tangram-components';
import { Question } from '@resultadosdigitais/tangram-react-icons';

import EventTrackerAPI from 'src/event-tracker/api';
import EventEmitter from 'src/services/event_emitter';
import I18n from 'src/locales/i18n';

import ZapierLogo from 'assets/images/zapier-logo.png';
import PlugaLogo from 'assets/images/pluga-logo.svg';
import IntegromatLogo from 'assets/images/integromat-logo.png';

export default class EmptySearch extends Component {
  constructor(props) {
    super();
    this.state = {
      categories: JSON.parse(props.categories || "[]")
    }
  }

  render() {
    return (
      <Theme value={ Theme.kinds.lina }>
        <Text
          style={{ marginBottom: 'var(--size-spacing-08)' }}
          token={ Text.tokens.TEXT_LG_BOLD }>
          { I18n.t('apps.empty_result.title') }
        </Text>

        <Text
          as={ 'div' }
          token={ Text.tokens.TEXT_SM_BOLD }>
          { I18n.t('apps.empty_result.suggestion') }
        </Text>

        <Text
          as={ 'div' }
          token={ Text.tokens.TEXT_SM_BOLD }>
          { I18n.t('apps.empty_result.categories') }
        </Text>

        <div style={{ marginTop: 'var(--size-spacing-05)' }}>
          { this.renderCategoryTags() }
        </div>

        <Text
          style={{ marginTop: 'var(--size-spacing-06)' }}
          token={ Text.tokens.TEXT_XS_REGULAR }>
          { I18n.t('apps.empty_result.integrators') }

          <Question
            title={ I18n.t('integrators_drawer.title') }
            style={ { cursor: 'pointer', fill: 'var(--color-primary-70)' } }
            size={ Question.sizes.xs }
            onClick={ () => this.handleIntegratorInfoClick() } />
        </Text>

        <ButtonGroup>
          <LinkButton
            kind={ LinkButton.kinds.secondary }
            href="https://zapier.com/apps/rd-station/integrations"
            onClick={ () => this.handleIntegratorClick('Zapier') }
            target="_blank">
            <img src={ ZapierLogo } style={{ width: '50px' }} />
          </LinkButton>

          <LinkButton
            kind={ LinkButton.kinds.secondary }
            href="https://pluga.co/ferramentas/rd_station/integracao/"
            onClick={ () => this.handleIntegratorClick('Pluga') }
            target="_blank">
            <img src={ PlugaLogo } style={{ width: '50px' }} />
          </LinkButton>

          <LinkButton
            kind={ LinkButton.kinds.secondary }
            href="https://www.integromat.com/en/integrations/rd-station"
            onClick={ () => this.handleIntegratorClick('Integromat') }
            target="_blank">
            <img src={ IntegromatLogo } style={{ width: '85px' }} />
          </LinkButton>
        </ButtonGroup>
      </Theme>
    );
  }

  renderCategoryTags() {
    const handleCategoryClick = (category) => {
      EventTrackerAPI.postAnonymousTrackingEvent({
        event_name: 'Visitor clicked on a category tag',
        category_name: category.name,
        language: I18n.language
      });

      window.location.href = `apps?by_categories[]=${category.slug}`
    }

    return this.state.categories.map((category) => {
      return (
        <div
          style={{ display: 'inline-block', margin: 'var(--size-spacing-01)' }}
          onClick={ () => handleCategoryClick(category) }
          key={ category.slug }>
          <Tag style={{ cursor: 'pointer' }}>
            { category.name }
          </Tag>
        </div>
      );
    });
  }

  handleIntegratorInfoClick() {
    EventTrackerAPI.postAnonymousTrackingEvent({
      event_name: 'Visitor clicked on the integrators info question icon',
      language: I18n.language
    });

    EventEmitter.emit('INTEGRATOR_TAG_CLICK');
  }

  handleIntegratorClick(integratorName) {
    EventTrackerAPI.postAnonymousTrackingEvent({
      event_name: 'Visitor clicked on the integrator link',
      integrator_name: integratorName,
      language: I18n.language
    });
  }
}
